import React, { Suspense, useContext } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect, useLocation } from "react-router-dom";
import LoginPage from "components/Login";
import AppContext from "AppContext";
import { LoginProvider } from "./LoginContext";

function LoginRoute({ ...props }) {
    const { loggedIn } = useSelector((state) => state.Login);
    const location = useLocation();

    const {
        api: {
            Settings: { Users, BusinessHours },
            Login,
        },
    } = useContext(AppContext);

    const hasSessionData = () => {
        return Boolean(localStorage.getItem("_t")) && Boolean(localStorage.getItem("_rt"));
    };

    if (loggedIn && hasSessionData()) {
        if (location.search) {
            const searchParams = new URLSearchParams(location.search);
            const hasTokenData = Boolean(searchParams.get("td"));
            const b64token = String(searchParams.get("d"));
            if (hasTokenData && b64token) {
                return <Redirect to={`/outside/t/${b64token}`} />;
            }
        }
        return <Redirect to="/" />;
    }

    return (
        <Route
            {...props}
            render={(routeProps) => (
                <Suspense fallback={<div>Loading path...</div>}>
                    <LoginProvider value={{ Login, Users, BusinessHours }}>
                        <LoginPage {...routeProps} />
                    </LoginProvider>
                </Suspense>
            )}
        />
    );
}

export default LoginRoute;
